<script>
import MultipleSelector from '@/components/Form/MultipleSelector.vue';

export default {
  name: 'purchase-main-type-selector',
  extends: MultipleSelector,
  created() {
    this.options = ['H', 'P', 'HV', 'HT', 'T', 'V', 'C', 'D', 'DV', 'TV', 'HTV', 'G', 'E', 'X'];
  },
};
</script>
